module.exports = {"231086100":"东宁镇","231086101":"三岔口镇","231086102":"大肚川镇","231086103":"老黑山镇","231086104":"道河镇","231086105":"绥阳镇","231086400":"绥阳林业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231086.json
// module id = 881
// module chunks = 0